<template>
  <button @click="$emit('click')" class="btn btn-success btn-block">
    <i class="fa fa-plus"></i> Thêm
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: "add-button",
  props: {}
};
</script>
